module.exports = __webpack_public_path__ + "img/pwa-installed-award.ab8f79f0.png";